import { type Command } from "@bfc-software/bfc-web-ui/ui/shared/command-palette";

export const globalCommandPaletteComands: Readonly<Command[]> = [];
